import React, {Component} from "react";
import PropTypes from "prop-types";
import {Sparklines, SparklinesBars} from 'react-sparklines';
import CountUp from 'react-countup';
import moment from 'moment';

class OnlineStudentsModal extends Component{

    //Renders
    renderList = (usersInCourse) => {
        return this.props.courses.map((course, index) => {
            return (
                <li key={index}>
                    {course.name}
                    <span>
                        {usersInCourse.filter(u => {
                            if(u.Course){
                                return u.Course.id === course.id;
                            }
                        }).length}
                    </span>
                </li>
            )
        });
    }

    renderCountUser = (total) => (
        <div className="sm-bottom20">
            <p>
                Users Right Now
            </p>
            <div className="font-60 font-300">
                <CountUp
                    start={0}
                    end={total}
                    duration={3.75}
                />
            </div>
        </div>
    );

    renderSparkline = (activeUsers) => {

        let minutes = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0

        ];

        let now = moment(new Date());
        let sparks = [];

        minutes.map((v, i) => {
            let relevant = activeUsers.filter(u => u.role == 'student' && now.diff(moment(u.lastActive), 'minutes') < i);
            minutes[i] = relevant.length;
        });

        return (
            <div id="sparkline">
                <Sparklines
                    data={minutes}
                    height={100}
                    width={300}
                    barWidth={8}
                    zeroAxis={false}
                >
                    <SparklinesBars
                        style={{fill: "#dbe6fd"}}
                        barWidth={8}
                    />
                </Sparklines>
            </div>
        )
    };

    renderContentModal = (usersOnline) => (
        <div
            className="modal-dialog modal-sm"
            role="document"
        >
            <div className="modal-content">
                <div
                    className="modal-body no-padding modal-style"
                >
                    <div className="sp-10">
                        {this.renderCountUser(usersOnline.length)}
                        <p className="border-bottom sp-bottom10">
                            Active Users Per Minute
                        </p>
                        {this.renderSparkline(usersOnline)}
                    </div>
                    <div className="sm-top20">
                        <ul className="active-visitor-list">
                            {this.renderList(usersOnline)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        return(
            <div
                className="modal fade"
                id="OnlineStudentsModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
            >
                {this.renderContentModal(this.props.students)}
            </div>
        );
    }
}

OnlineStudentsModal.propTypes = {
    usersOnline: PropTypes.shape({
        total: PropTypes.number.isRequired,
        countUsersInCourses: PropTypes.array.isRequired,
        activeUsers: PropTypes.array.isRequired
    })
};

export default OnlineStudentsModal;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardAdmin/OnlineStudentsModal.js